import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {readAccountShipmentInfoApi} from "../../../../../api/correspondent/CorresspondentApi";
import {
    CreateCorrespondentInterface
} from "../../../../customer/correspondent/create/interface/CreateCorrespondentInterface";

export const useReadAccountShipmentInfo = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (searchData: CreateCorrespondentInterface) => readAccountShipmentInfoApi(searchData),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
